module.exports = __webpack_public_path__ + "img/page-home-list.8c1dc9ab.png";